if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.productData = JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent);
      if (this.productData.hide_soldout) {
        const availableVariants = this.productData.variants.filter(x=>x.available);
        if (availableVariants.length==0) {
          this.classList.add('sold-out-hide');
        } else {
          this.productData.variants = availableVariants;
          const variantInput = this.querySelector('[data-variant-id]');
          if (!this.productData.variants.find(x=>x.id==variantInput.value/1)) {
            variantInput.value = this.productData.variants[0].id;
          }
        }
      }
      this.variantsElement = this.querySelector('product-variants');
      this.sellingPlanElement = this.querySelector('product-selling-plan');
      this.quantityElement = this.querySelector('.quantity-input');
      this.badgesSale = this.querySelectorAll('.badge.sale');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
      this.optionValues = {}
      const requiredOptionsSetting = ([] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options.filter(x=>(requiredOptionsSettingUnique.indexOf(x)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && this.getOptionValues(x).length>1);
      this.originalRequiredOptions = [...this.requiredOptions];
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
    }

    getOptionValues(optionName) {
      if (!this.optionValues[optionName]) {
        function filterUnique(value, index, array) {
          return array.indexOf(value) === index;
        }
        var ix = this.productData.options.indexOf(optionName);
        this.optionValues[optionName] = this.productData.variants.map(v=>v['option'+(1+ix)]).filter(filterUnique);
      }
      return this.optionValues[optionName];
    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.originalRequiredOptions.length;
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getCurrentPlan() {
      return this.sellingPlanElement?.getCurrentPlan();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
    onVariantChange() {
      //lightweight update of elements that not worth creating their own components
      var variant = event.detail.variant;
      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant.title;
      });
      this.badgesSale.forEach(element=>{
        var sale = '';
        var percent = Math.floor((1 - variant.price / variant.compare_at_price) * 100);
        if (percent > 0) {
          sale = element.dataset.msgtpl.replace('[percent]', percent);
        }
        element.style.display = variant.available && sale ? '' : 'none';
        element.innerHTML = sale;
      });
      this.badgesSoldOut.forEach(element=>{
        element.style.display = variant.available ? 'none' : '';
      });}
  }
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      
      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
      }

      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          var origSwatches = self.querySelector('product-swatch.color-swatches');
          if (origSwatches) {
            //need to duplicate the whole product-variants component
            var pv = origSwatches.closest('product-variants');
            var tag = pv.outerHTML.replace('name="id"', '');
            var wrapper = document.createElement('div');
            wrapper.style.display = 'none';
            //must insert as Element, not HTML, otherwise the component would be reconstructed
            self.querySelector('add-to-cart-form').insertAdjacentElement('beforebegin', wrapper);
            wrapper.innerHTML = tag;
            //move the swatches inside the add-to-cart-form component to use existing css.
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', wrapper.querySelector('product-swatch.color-swatches'));
          }
        }, 10);
      }
      if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
        window.LinkPrefetch.addHoverListener(this);
      }
    }

    openOptions(e) {
      e.preventDefault()
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var image = variant.featured_media && super.isSwatchSelected() ? variant.featured_image : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }

      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      //update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.originalRequiredOptions.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }
    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');
      if (this.button && (this.button != this.mainAddButton)) {
        this.button.addEventListener('click', (event)=>{
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainAddButton.click();
        });
      }

      this.mainElement.addEventListener('variantChange', (e)=>{
        var requiredBtn = this.querySelector('.btn.selection-required');
        if (this.required() && requiredBtn) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;
        } else if(e.detail.variant && e.detail.variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          var addbutton = this.querySelector('.btn.add');
          if(addbutton){
            addbutton.style.display = '';
            this.querySelector('.sold-out-message').style.display = 'none';
            if (requiredBtn) requiredBtn.style.display = 'none';
          }
      	} else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          var addbutton = this.querySelector('.btn.add');
          if(addbutton){
            addbutton.style.display = 'none';
            this.querySelector('.sold-out-message').style.display = '';
            if (requiredBtn) requiredBtn.style.display = 'none';
          }
        }
      });
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a'; //english support only
        this.requiredMessage = lngg.product_main__select_option_label.replace('Select a ', 'Select ' + prep + ' ').replace(new RegExp(/{{ *option_name *}}/), label);
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sku')) {
  class ProductSKU extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant) {
          if(e.detail.variant.sku) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.sku;
          }else{
            this.closest('.module').style.display = 'none';
          }
      	}
      });
    }
  }
  customElements.define('product-sku', ProductSKU);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector('.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }
    fixVariantOption(optionValue) {
      // There are a few products that have option names including commas, which affects the way the filterMedia works,
      // so this function basically replaces the comma by a plus
      if (optionValue.indexOf(',') < 0) return optionValue;
      let retValue = optionValue;
      let variantFixers = 'White Gold,Yellow Gold:White Gold+Yellow Gold;Rose Gold,White Gold:Rose Gold+White Gold';
      if (variantFixers.indexOf(';') < 0) return retValue;
      let variantFixersArray = variantFixers.split(';');
      variantFixersArray.forEach(variantFixer => {
        let variantFixerParts = variantFixer.split(':');
        if (variantFixerParts.length > 0) {
          retValue = retValue.replace(variantFixerParts[0], variantFixerParts[1])
        }
      })
      return retValue;
    }
    filterMedia(variant) {
      let translatedMedia = GalleryHelper.translateAlts(this.mainElement.productData);
      let displayedItems = [];
      translatedMedia.forEach((media)=>{
        var show = true;
        if(media.alt && media.alt!="") {
          var filter = media.alt.split(';');
          filter.forEach((f)=>{
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              var optionIndex = this.mainElement.productData.options.findIndex(x=>x==key.trim());
              if(optionIndex>=0 && values) {
                var found = false;
                values.split(',').forEach((value)=>{
                  let variantOptionValue = this.fixVariantOption(variant.options[optionIndex])
                  if(variantOptionValue==value.trim()) {
                    found = true;
                  }
                });
                show = found;
              }
            }
          });
        }
        let isThumbnail = media.alt && media.alt.indexOf('Thumbnail-only') > -1
        if(show && !isThumbnail) { // Removes thumbnails. They are using 'Thumbnail-only' in the alt for images to be displayed only in the PLP
          let el = this.querySelector('[data-media-id="'+media.id+'"]')
          if (el) {
            el.style.display = 'block';
            displayedItems = [...displayedItems, media.id]
          }
        } else {
          let el = this.querySelector('[data-media-id="'+media.id+'"]')
          if (el) el.style.display = 'none';
        }
      });
      
      if(this.slider) {
        this.slider.refresh();
        GalleryHelper.centerVertical(this, displayedItems, this.itemsWrapper)
        //GalleryHelper.moveFirst(this, this.slider)
        setTimeout(() => {
          this.slider.moveToSlide(0)
        }, 2)
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    
    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll('.media-wrap, .thumb-wrap').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant);
        if(variant.featured_media && this.mainElement.isSwatchSelected()) {
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.media-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: this.querySelector('.keen-dots')
          }
        }
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 0.001) +'rem)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }
        
        setTimeout(() => {
          this.slider = new KeenSlider(this.itemsWrapper, {
            mode: "snap",
            loop: false,
            wheel: false,
            slidesPerView: 1,
            slideChanged: (keen)=>{
              $s.pauseAllMedia(this);
              this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
            },
            breakpoints
          });
        }, 200)
        
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');
      this.forceCenter = this.dataset.forceCenter === 'true'

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle=='thumbnails') || ($s.media.isMediumUp && (this.desktopStyle=='carousel') )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.thumb-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: 4,
          spacing: 0,
          centered: false,
          vertical: false
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: 3,
          spacing: 0,
          centered: false,
          vertical: false
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: false,
          centered: this.forceCenter,
          slidesPerView: 9,
          spacing: 0,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints,
          ...(this.desktopOrientation=='vertical' ? {
            vertical: true,
            slidesPerView: 5
          } : {})
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.finalPriceElement = this.querySelector('.final');
      this.comparePriceElement = this.querySelector('.compare');
      this.customSelect = this.mainElement.querySelector('custom-select');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false,
      this.addonPrice = 0;


      this.listenEvents = ['variantChange','sellingPlanChange', 'addonChange'];
      if (this.multiplyQuantity)
        this.listenEvents.splice(1, 0, 'quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var data = this.mainElement.getCurrentPlan() || this.mainElement.getCurrentVariant();
          if(this.customSelect && event === 'addonChange'){
            this.addonPrice = e.detail.variantPrice;
          }          
        	if(data) {
            var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;

        		this.finalPriceElement.innerHTML = $s.formatMoney(this.addonPrice + data.price * quantity).replace('.00','');

            if(data.compare_at_price > data.price) {
              this.comparePriceElement.classList.remove('hide');
              this.comparePriceElement.innerHTML = $s.formatMoney(this.addonPrice + data.compare_at_price * quantity).replace('.00','');
            } else {
              this.comparePriceElement.classList.add('hide');
              this.comparePriceElement.innerHTML = '';
            }
        	} else {
        		this.finalPriceElement.innerHTML = '';
            this.comparePriceElement.innerHTML = '';
        	}
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement.variantsInstances = (this.mainElement.variantsInstances || 0) +1;
      this.instanceIndex = this.mainElement.variantsInstances;
      this.variantInput = this.querySelector('[data-variant-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;
      this.mainElement.addEventListener('variantChange', (event)=> {
        if(window?.ab_pdp && !notAbPdp){
        const variantColor = event.detail.variant.title.split(" / ")[0].replace(",","+")
        if(this.mainElement.productData.variants.length > 1){
          document.querySelectorAll(".gallery-v2 img").forEach(img => {
            if(variantColor.includes("+")){
              if(img.alt.includes(variantColor) && img.alt.includes("+")){
                img.style.display = "block"
              }else{
                img.style.display = "none"
              }
            }else{
              if(img.alt.includes(variantColor) && !img.alt.includes("+")){
                img.style.display = "block"
              }else{
                img.style.display = "none"
              }
            }
            if(img.parentElement.classList.contains("gal-main")){
              if(img.alt.includes(",") && img.alt != event.detail.variant.featured_media.alt){
                img.style.display = "none"
              }
            }
          })
          /* document.querySelectorAll(`.gallery-v2 img[alt*="${variantColor}"]${variantColor.includes("+") ? "": ":not([alt*='+'])"}`).forEach(item => {
            item.style.display = "block"
          })
          document.querySelectorAll(`.gallery-v2 img:not([alt*="${variantColor}"])`).forEach(item => {
            item.style.display = "none"
          }) */
        }
        }
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant);
        }
      })

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
        this.bindInfoElements();
      }, 10);
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getCurrentVariant() {
      let variant = this.mainElement.productData.variants.find(x => x.id == this.variantInput.value);

      if (window.VtInf) {
          let variantInfoEncode = decodeURIComponent(escape(atob(window.VtInf)));
          let variantInfo = JSON.parse(variantInfoEncode);

          let yellowGoldVariants = variantInfo.filter(variant => variant.title.includes("Yellow Gold"));
          let availableVariant = yellowGoldVariants.find(variant => parseInt(variant.inventory_quantity) > 0) 
                              || yellowGoldVariants.find(variant => variant.available === "true") 
                              || variantInfo.find(variant => parseInt(variant.inventory_quantity) > 0) 
                              || variantInfo.find(variant => variant.available === "true") 
                              || yellowGoldVariants[0];

          if (availableVariant) {
              variant = this.mainElement.productData.variants.find(x => x.id == availableVariant.id) || variant;
          }
      }

      if (!variant) {
          variant = this.mainElement.productData.variants.find(x => x.title.includes("Yellow Gold")) 
                || this.mainElement.productData.variants[0];
      }
      return variant;
    }


    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));
      //new sticky
      const optionsATC = variant.title.split(" / ")
      if(window["atc_img"]){
        atc_img.src = variant.featured_image.src
      }
      if(window["atc_color"]){
        atc_color.value = optionsATC[0];
      }
      if(window["atc_variants"]){
        atc_variants.value = optionsATC[1]
      }
      //new sticky
      if (this.swatchImg) {
          //var variant = this.mainElement.productData.variants.
          var options = ['option1', 'option2', 'option3'];
          var imgOption = options.splice(this.swatchImg.dataset.option/1 -1 ,1);
          this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
            var label = radio.parentNode.querySelector('.label-inner');
            
            var matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value && v[options[0]]==variant[options[0]] && v[options[1]]==variant[options[1]]);
            if (!matchingVariant) {
              matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value);
            }
            if (matchingVariant.featured_image) {
              label.style.backgroundImage = 'url(' +$s.imgUrlFilter(matchingVariant.featured_image.src, this.swatchImg.dataset.zoomSwatches ? '250x' : '150x')+ ')';
              if (this.swatchImg.dataset.zoomSwatches) {
                label.style.backgroundSize = this.swatchImg.dataset.zoomScale;
                label.style.backgroundPosition = this.swatchImg.dataset.zoomPosition;
              }
            } else {
              label.style.backgroundImage = '';
            }
          });

      }
      window.CurrentVnt = variant;
    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('button.option-info-link');
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink) {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content" style="width: ${infoLink.dataset.width}rem">
                <img src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

    getOptionValues(currentVariant) {
      var options = [];
      this.mainElement.productData.options.forEach((option, index)=>{
        if(index==0) {
          var optionValues = this.mainElement.productData.variants.map((variant)=>{return {
            value: variant.options[index], 
            available: variant.available
          }});
        }
        if(index==1) {
          var optionValues = this.mainElement.productData.variants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        if(index==2) {
          var optionValues = this.mainElement.productData.variants.filter(
            x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
          ).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        var optionValuesUnique = [];
        optionValues.forEach((option, key)=>{
          if(!optionValuesUnique.find(x=>x.value==option.value)) {
            if(option.available) {
              optionValuesUnique.push(option);
            } else {
              if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                optionValuesUnique.push(option);
              }
            }
          }
        });
        options.push(optionValuesUnique);
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-variant-edit')) {
  class ProductVariantEdit extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.toggles = this.querySelectorAll('.toggle');
      this.toggles.forEach(btn=>{btn.addEventListener('click', this.onToggle.bind(this))});
      this.editing = false;
    }
    onToggle() {
      this.editing = !this.editing;
      var divVariants = this.querySelector('.variants');
      var divInfo = this.querySelector('.info');
      if (this.editing) {
        $s.expand([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.add('open')});
      } else {
        $s.collapse([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.remove('open')});
      }
    }
  }
  customElements.define('product-variant-edit', ProductVariantEdit);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.colorSwatchesOptions = ["Color","Metal Color"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      
      // Built SKU for composed products
      this.dataSkuOptions = this.dataset.skuOptions || "";

      // Popup Helper
      this.helperTitle = this.dataset.helper;
      this.helperContentId = this.dataset.helperId;
      this.helperIsHtmlPopup = this.dataset.helperIsHtmlPopup === 'true';
      this.helperHtmlUrl = this.dataset.helperHtmlUrl;
      this.helperHtmlSections = this.dataset.helperHtmlSections;

      // Options hidden by metafield
      this.disabledOptions = this.dataset.disabledOptions || '';

      this.buildOptionSelector();
      if(this.helperTitle) this.addHelper()
    }

    addHelper() {
      
      var elHelperWrap = document.createElement('div');
      elHelperWrap.classList.add('option-size-guide-wrap')
      var elHelperBtn = document.createElement('button');
      elHelperBtn.innerHTML = this.helperTitle;
      elHelperBtn.classList.add('btn-helper')
      elHelperWrap.appendChild(elHelperBtn)
      this.appendChild(elHelperWrap)

      elHelperBtn.addEventListener('click', event => {
        event.preventDefault();
        this.loadSizeGuideHelperPopup()
      })

    }

    loadSizeGuideHelperPopup() {
      let contentPopup = document.querySelector(`#${this.helperContentId}`);
      let isHtmlPopup = this.helperIsHtmlPopup;
      let htmlUrl = this.helperHtmlUrl;
      let htmlSections = this.helperHtmlSections;
      if (isHtmlPopup) {
        let maxSections = 5;
        let htmlSectionIds = htmlSections.split(',');
        // chunkify sections to build promises with a max of [maxSections]
        let htmlSectionChunks = htmlSectionIds.length > maxSections ? htmlSectionIds.reduce((acc, _, i) => (i % maxSections) ? acc  : [...acc, htmlSectionIds.slice(i, i + maxSections)], []) : [htmlSectionIds]
        let htmlSectionPromises = htmlSectionChunks.map(sectionChunk =>  new Promise((resolve, reject) => {
          $s.getJson({url: `${htmlUrl}${htmlUrl.indexOf('?') >= 0 ? '&' : '?'}sections=${sectionChunk.join(',')}`, success: function(data){
            resolve(data)
          }})
        }));
        Promise.all(htmlSectionPromises).then(results => {
          let allResults = results.reduce((acc, arr) => ({...acc, ...arr}), {});
          let htmlContent = htmlSectionIds.map(sectionId => allResults[sectionId] ? allResults[sectionId] : "" )
          contentPopup.querySelector('.inner').innerHTML = htmlContent.join(",");
          $s.openModal(contentPopup, 'popup-size-guide-pdp', {closeMethods: ['overlay', 'button', 'escape']});
        }).catch(error => console.log(error))
      } else {
        $s.openModal(contentPopup, 'popup-size-guide-pdp', {closeMethods: ['overlay', 'button', 'escape']});
      }
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
    	var optionElement = document.createElement('div');
  		var html = `
  			<div class="option-name small-label">
          ${this.label}${this.infoIcon}: 
          <span class="option-value">${defaultValue}</span>
          ${this.infoLink}
        </div>
  			<div class="swatch-group flex flex-wrap"></div>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, defaultValue);
    }

    buildDataSkuOptions(skuOptions) {
      var optionsParts = skuOptions.split("|");
      var options = optionsParts.length > 0 ? optionsParts[0] : skuOptions;
      var diamond = optionsParts.length > 1 ? optionsParts[1] : null;
      if (options && diamond) {
        var diamondParts = diamond.split('-');
        var diamondGia = diamondParts.length > 0 ? diamondParts[diamondParts.length - 1] : null;
        diamondGia = diamondGia.replace('GIA#', '').trim()
        var optionsList = options.split(',')
        optionsList = optionsList.length > 0 ? optionsList.filter(o => o.trim()) : []
        optionsList = optionsList.map(option => {
          var optionChunks = option.split(':');
          var optionValue = optionChunks.length > 0 ? optionChunks[0] : '';
          var optionSku = optionChunks.length > 1 ? (optionChunks[1].indexOf('-') > -1 ? optionChunks[1].split('-')?.[0]?.toLowerCase() : '') : '';
          return {
            value: optionValue,
            sku: `${optionSku}-${diamondGia}`
          }
        })
        return optionsList
      }
      return null
    }

    buildOptions(options, defaultValue) {
      var dataSkuOptions = this.dataSkuOptions ? this.buildDataSkuOptions(this.dataSkuOptions) : null;
    	var html = '';
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        // This disables options based on product.metafields.custom.disable_option
        var disabledOptions = this.disabledOptions.indexOf(',') > -1 ? this.disabledOptions.split(',') : [this.disabledOptions];
        disabledOptions = disabledOptions.filter(o => o.trim());
        var id = `swatch-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
  			html += `
          <div class="swatch" data-available="${option.available}" 
            ${dataSkuOptions && dataSkuOptions.length > 0 ? `data-sku="${dataSkuOptions.find(o => o.value === option.value)?.sku}"` : ''}
            ${disabledOptions.find(o => o === $s.escapeDomAttribute(option.value)) ? `style="display: none !important;"` : ''}>
            <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" />
  				  <label class="animation ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? 'color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}" for="${id}">
              <div class="animation label-inner">
              	<span>${option.value}</span>
              </div>
            </label>
          </div>
  			`;
  		});
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.helperTitle = this.dataset.helper;
      this.helperContentId = this.dataset.helperId;
      this.helperIsHtmlPopup = this.dataset.helperIsHtmlPopup === 'true';
      this.helperHtmlUrl = this.dataset.helperHtmlUrl;
      this.helperHtmlSections = this.dataset.helperHtmlSections;
      
      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          select.querySelector('[disabled]').remove();
        }, {once: true})
      }

      if(this.helperTitle) this.addHelper()
      this.addVariantLabel()
    }

    addVariantLabel() {
      this.elLabel = this.querySelector('.option-name span');
      this.mainElement.addEventListener('variantChange', event => {
        this.elLabel.innerHTML = `${this.label}: <strong>${event.detail.variant[`option` + this.optionNumber]}</strong>`
      })
    }

    addHelper() {
      var elLabel = this.querySelector('.option-name');
      var elHelperBtn = document.createElement('button');
      elHelperBtn.innerHTML = this.helperTitle;
      elHelperBtn.classList.add('btn')
      elHelperBtn.classList.add('btn-helper')
      elLabel.innerHTML = elLabel.innerHTML.replace(':', '')
      elLabel.appendChild(elHelperBtn)

      elLabel.classList.add('flex', 'align-items-center', 'justify-content-between');

      



      elHelperBtn.addEventListener('click', event => {
        console.log('clicked');
        event.preventDefault();
        this.loadSizeGuideHelperPopup()
        /*
        var contentPopup = document.querySelector(`#${this.helperContentId}`);
        if (helperIsHtmlPopup) {
          $s.getJson({url: `${helperHtmlUrl}${helperHtmlUrl.indexOf('?') >= 0 ? '&' : '?'}sections=${helperHtmlSections}`, success: function(data){
            if (data) contentPopup.querySelector('.inner').innerHTML = ''
            var htmlContent = helperHtmlSections.split(',').map(sectionId => data[sectionId] ? data[sectionId] : "" )
            contentPopup.querySelector('.inner').innerHTML = htmlContent.join(",")
            $s.openModal(contentPopup, 'popup-size-guide-pdp', {closeMethods: ['overlay', 'button', 'escape']});
          }})
        } else {
          $s.openModal(contentPopup, 'popup-size-guide-pdp', {closeMethods: ['overlay', 'button', 'escape']});
        }*/
      })

    }

    loadSizeGuideHelperPopup() {
      let contentPopup = document.querySelector(`#${this.helperContentId}`);
      let isHtmlPopup = this.helperIsHtmlPopup;
      let htmlUrl = this.helperHtmlUrl;
      let htmlSections = this.helperHtmlSections;
      if (isHtmlPopup) {
        $s.loadSizeGuidePopup(contentPopup, this.helperHtmlUrl, htmlSections)
      } else {
        $s.openModal(contentPopup, 'popup-size-guide-pdp', {closeMethods: ['overlay', 'button', 'escape']});
      }
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      var html = `
        <label class="option-name small-label" for="${optionId}">
        <span>${this.label}${this.infoIcon}</span> 
        ${this.infoLink}
        </label>
        <div class="field ${optionValues.length === 1 ? 'dropdown-readonly' : ''}">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path d="M27,10,16,22,5,10"/></svg> 
          <select id="${optionId}" name="swatch-${optionId}" ${optionValues.length === 1 ? 'disabled' : ''}></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (this.required()) {
  			html += `<option value="${defaultValue || ''}" disabled selected>${lngg.general__forms__select_option_label}</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
  		options.forEach((option, index) => {
        let soldOut = '';
        if (!this.classList.contains('not-copy-select')) {
          soldOut = (!option.available ? lngg.product_main__sold_out_option_value : '');
        }
        html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
      });
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}

      if (options.length === 1) {
        select.disabled =  true;
        select.closest(".field").classList.add("dropdown-readonly")
      } else {
        select.disabled =  false;
        select.closest(".field").classList.remove("dropdown-readonly")
      }
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.onScroll.bind(this), 50);
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
    }

    connectedCallback() {
      if (this.positionElement) {
        window.addEventListener('scroll', this.scrollHandler);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
    }

    onScroll(event) {
      var bounds = this.positionElement.getBoundingClientRect();
      if (bounds.bottom < 0) {
        if (!this.showing) {
          this.classList.add('open');
          this.showing = true;
        }
      } else {
        if (this.showing) {
          this.classList.remove('open');
          this.showing = false;
        }
      }

    }

  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('product-main');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root_url;
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}




GalleryHelper = new function () {
    this.moveFirst = (el, s) => {
      if (Array.from(el.querySelectorAll('.iframe-wrap')).length > 0 || Array.from(el.querySelectorAll('.video-wrap')).length > 0) s.moveToIdx(1)
    } 
    this.translateAlts = (product) => {
      let productOptions = product.options;
      let productMedia = product.media;
      let productMediaTranslated = productMedia.map(media => ({ ...media, alt: this.translateAlt(media.alt, productOptions )}));
      return productMediaTranslated;
    }
    this.translateAlt = (alt, options) => {
      if (!alt || alt.indexOf('^') === -1) return alt;
      let altOptionsParts = alt.split('^'); 
      let altOptionsSerialized = altOptionsParts.length > 0 ? altOptionsParts[0] : altOptionsParts; //alt.indexOf('^') > -1 ? alt.split('^')?.[0] : alt;
      let altOptionsExtra = altOptionsParts.length > 0 ? altOptionsParts[1] : ""
      let altOptions = altOptionsSerialized.indexOf(',') > -1 ? altOptionsSerialized.split(',') : [altOptionsSerialized];
      altOptions = altOptions.map((o, i) => `${options[i]}:${this.removeOrder(o)}`).join(';')
      return `${altOptions}${altOptionsExtra ? `,${altOptionsExtra}` : ''}`
    }
    this.removeOrder = (alt) => {
      return alt.indexOf('-') > -1 ? alt.split('-')?.[0] : alt;
    }
    this.centerVertical = (mainElement, items, wrapper) => {
      
      let elDisplayedItems = mainElement.querySelectorAll(items.map(item => `[data-media-id="${item}"]`).join(','));
      let totalDisplayedHeight = Array.from(elDisplayedItems).reduce((tot, elDisplayedItem) => tot + elDisplayedItem.getBoundingClientRect().height, 0);
      let wrapperHeight = mainElement.getBoundingClientRect().height;
      wrapper.style.marginTop = '0'
      if (mainElement.nodeName === 'PRODUCT-THUMBS' 
          && mainElement.dataset.centerVertical === 'true' 
          && totalDisplayedHeight < wrapperHeight) {
            //console.log('centering', wrapperHeight, totalDisplayedHeight);
            wrapper.style.marginTop = `${Math.floor((wrapperHeight - totalDisplayedHeight)/2)}px`
          }
    }
}